<template>
  <div id="update-data-page">
    <h2 class="intro-y text-lg font-medium mt-10">
      更改部分
    </h2>

    <performance-report-version-form v-if="mounted && checkPermission(permissions, 'system.performance-report.manage')" :data="data"></performance-report-version-form>

    <div v-else-if="mounted">
      <div class="alert alert-danger show mt-2" role="alert">沒有權限查看</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['auth', 'permissions'],
  data() {
    return {
      mounted: false,
      data: null
    }
  },
  watch: {
    auth(val) {
      if (val) {
        this.init()
      }
    },
    permissions() {
      this.init()
    }
  },
  async mounted() {
    if (!this.auth) {
      return
    }

    await this.init()
  },
  methods: {
    async init() {
      if (this.permissions) {
        await this.loadData()

        setTimeout(() => {
          this.mounted = true
        }, 500)
      }
    },
    async loadData() {
      const response = await this.getPerformanceReportVersion(this.$route.params.versionId)
      if (response.code === 0) {
        this.data = response.data
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
